import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import { of } from 'rxjs/observable/of';
import { fetchConfluenceSpaces } from '../actions';
import { UPDATE_PERSONALIZATION_SITE_TRAITS } from '../actions/personalization-site-traits';
import { type ActionsObservable } from 'redux-observable';

export default (action$: ActionsObservable<any>, store: any) =>
	action$.ofType(UPDATE_PERSONALIZATION_SITE_TRAITS).switchMap(() => of(fetchConfluenceSpaces()));
